import React from 'react';
import { Link } from 'react-router-dom';
import EquipmentImage from './EquipmentImage';
import useEquipment from '../hooks/useEquipment';

export default function EquipmentCard({ equipment, variant }) {
  const product = useEquipment(equipment);
  if (variant === 'home') {
    return <Link className="home-product-link" to={product.path}>
      <img src={product.image.src} alt={product.image.alt} />
      <span>{product.name}</span>
    </Link>;
  }
  return <Link className="equipment-card" to={product.path}>
    <EquipmentImage image={product.image} />
    <div className="equipment-card-copy">
      <h2>{product.name}</h2>
    </div>
  </Link>;
}
